import { render } from "./LessonsGeoRestrictionsDialog.vue?vue&type=template&id=2a41d402&scoped=true"
import script from "./LessonsGeoRestrictionsDialog.vue?vue&type=script&lang=js"
export * from "./LessonsGeoRestrictionsDialog.vue?vue&type=script&lang=js"

import "./LessonsGeoRestrictionsDialog.vue?vue&type=style&index=0&id=2a41d402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a41d402"]])

export default __exports__